/* eslint-env jest */
import { yearbookViewEvent, yearbookPrice, YEARBOOK_VIEW_STATES } from './yearbookViewEvent';

// yearbook_viewed records which of the landing page's three outcomes a parent
// saw (the Tue Nov 3 yearbook campaign lands here) and the price on screen.
// It must agree with the page's own branches, and stay quiet while loading.
const student = { id: '42', school: { id: '7' } };
const yearbook = (prices) => ({ id: '900', campaign: 'yb2027', options: [{ prices }] });

describe('yearbookViewEvent', () => {
  it('is null until a student is found', () => {
    expect(yearbookViewEvent({ student: undefined, packageDone: true })).toBeNull();
  });

  it("reports the in-window price, preferring the school's own", () => {
    const yb = yearbook([{ price: 40 }, { price: 35, schoolId: 7 }]);

    expect(yearbookViewEvent({ student, yearbook: yb, packageDone: true })).toEqual({
      state: YEARBOOK_VIEW_STATES.PRICE_AVAILABLE, packageId: '900', price: 35,
    });
  });

  it('falls back to the generic price', () => {
    const event = yearbookViewEvent({ student, yearbook: yearbook([{ price: 40 }]), packageDone: true });

    expect(event.price).toBe(40);
  });

  it('records no price, rather than throwing, when the package has none', () => {
    const event = yearbookViewEvent({ student, yearbook: yearbook([]), packageDone: true });

    expect(event).toEqual({ state: 'price_available', packageId: '900', price: undefined });
  });

  it('is null while the package or the home-delivery lookup is still loading', () => {
    expect(yearbookViewEvent({ student, packageDone: false })).toBeNull();
    expect(yearbookViewEvent({ student, packageDone: true, homeFetching: true })).toBeNull();
  });

  it('reports ship-to-home with the home price', () => {
    const homeDelivery = { state: 'home', package: { id: 901, home_price: '44.99' } };

    expect(yearbookViewEvent({ student, packageDone: true, homeDelivery })).toEqual({
      state: YEARBOOK_VIEW_STATES.SHIP_TO_HOME, packageId: 901, price: 44.99,
    });
  });

  it('reports deadline passed for a closed program, a failed lookup, or an active answer with no window', () => {
    const closed = yearbookViewEvent({ student, packageDone: true, homeDelivery: { state: 'closed' } });
    const failed = yearbookViewEvent({ student, packageDone: true, homeDelivery: undefined });

    expect(closed).toEqual({ state: YEARBOOK_VIEW_STATES.DEADLINE_PASSED, homeDeliveryState: 'closed' });
    expect(failed.state).toBe(YEARBOOK_VIEW_STATES.DEADLINE_PASSED);
  });
});

describe('yearbookPrice', () => {
  it('is 0 with no package, as the form has always shown', () => {
    expect(yearbookPrice(undefined)).toBe(0);
  });
});
